import { render, staticRenderFns } from "./CopyWrite.vue?vue&type=template&id=38fe043c&"
import script from "./CopyWrite.vue?vue&type=script&lang=js&"
export * from "./CopyWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports